//Loading especialmente para los botones 
import React from 'react'
import './buttonSpinnet.css'

function SpinnetButton() {
    return (
        <div>
        <div className="nb-spinner"></div>
      </div>
    )
}

export default SpinnetButton